import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Upload, FileText, Users } from 'lucide-react';
import { ICPDescriptionUpload } from './ICPDescriptionUpload';
import { ICPVibeMethod } from './ICPVibeMethod';

export const ICPIdeation: React.FC = () => {
  const [activeMethod, setActiveMethod] = useState<string>('vibe');

  return (
    <div className="flex-1 p-6 overflow-auto">
      <div className="max-w-6xl mx-auto">
        <Tabs value={activeMethod} onValueChange={setActiveMethod} className="w-full">
          <TabsList className="grid w-full grid-cols-2 bg-slate-800 border-slate-700">
            <TabsTrigger 
              value="vibe" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-purple-600 data-[state=active]:to-pink-600 data-[state=active]:text-white"
            >
              <Users className="w-4 h-4 mr-2" />
              Vibe My ICP
            </TabsTrigger>
            <TabsTrigger 
              value="description" 
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-purple-600 data-[state=active]:to-pink-600 data-[state=active]:text-white"
            >
              <FileText className="w-4 h-4 mr-2" />
              Upload Description
            </TabsTrigger>
          </TabsList>

          <TabsContent value="vibe" className="mt-6">
            <Card className="bg-slate-800 border-slate-700">
              <CardHeader className="bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-t-lg">
                <CardTitle className="flex items-center gap-2">
                  <Users className="h-5 w-5" />
                  Vibe My ICP
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6">
                <ICPVibeMethod />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="description" className="mt-6">
            <Card className="bg-slate-800 border-slate-700">
              <CardHeader className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-t-lg">
                <CardTitle className="flex items-center gap-2">
                  <Upload className="h-5 w-5" />
                  Upload ICP Description
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6">
                <ICPDescriptionUpload />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}; 